import { ScriptStrategy } from 'gatsby';
import { ConversionPixelData } from './types';
import renderTrackingPixel from '../../lib/trackingPixel';

const BASE_URL = 'https://insight.adsrvr.org/track/pxl/';

export default function renderConversionPixel(
    advertiserId: string,
    {
        ct,
        alt,
        locationName,
        appointmentId,
        appointmentDate,
    }: ConversionPixelData,
    strategy: Exclude<
        ScriptStrategy,
        ScriptStrategy.offMainThread
    > = ScriptStrategy.idle,
): void {
    const url = new URL(BASE_URL);
    url.searchParams.set('adv', advertiserId);
    url.searchParams.set('fmt', '3');
    url.searchParams.set('ct', ct);

    if (locationName) {
        url.searchParams.set('td1', locationName);
    }

    if (appointmentId) {
        url.searchParams.set('td2', appointmentId);
    }

    if (appointmentDate) {
        const date = new Date(appointmentDate);
        const dateString = [
            (date.getMonth() + 1).toString().padStart(2, '0'),
            date.getDate().toString().padStart(2, '0'),
            date.getFullYear(),
        ].join('/');

        url.searchParams.set('td3', dateString);
    }

    renderTrackingPixel(url.toString(), alt, strategy);
}
